import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import './overridden-placeholder.css'
import RGL, {WidthProvider} from "react-grid-layout";
import React, {useContext, useState, useEffect, useMemo, forwardRef, useRef} from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import useAxios from "axios-hooks";
import axios from 'axios';
import {AuthContext, ThemeContext} from "../../contexts";
import { 
    Backdrop, Checkbox, FormControlLabel, Typography
} from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import Moment from "moment";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import GaugeComponent from 'react-gauge-component';
import Paper from "@material-ui/core/Paper";
import { TimeSeries, TimeRange, } from "pondjs";
import ContainerDimensions from "react-container-dimensions";
import CustomLoader from "../../components/CustomLoader";
import MonthPicker from "../create_new_relationship/rules_components/MonthPicker";

// Error Boundary generico
class GaugeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Aggiorna lo stato per mostrare il fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Qui puoi loggare l'errore a un servizio di monitoring
    console.error("Errore catturato nel GaugeComponent:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI in caso di errore
      return <div>Errore nel gauge, impossibile renderizzare il componente.</div>;
    }

    return this.props.children;
  }
}

const devicesConf = {
    "ename:Ossigeno_disciolto":{
        "key": "gs1:MassConcentration",
        "label": "Ossigeno disciolto",
        "order": 1,
        "udm": "mg/L",
        "min": 6,
        "max": 12,
        "deviceFile": "ossigeno",
        "gauge":{
            "id": "ossig",
            "arcs": [
                [0, 3, 0],
                [3,5,1],
                [5,10,2]
            ]
        },
        "outliers": {
            "min_percentile": 0.05,
            "max_percentile": 0.95
        }
    },
    "ename:Temperatura":{
        "key": "gs1:Temperature",
        "label": "Temperatura",
        "order": 0,
        "udm": "°C",
        "min": 13,
        "max": 30,
        "deviceFile": "temperatura",
        "gauge": {
            "id": "temp",
            "arcs": [
                [0, 10, 0],
                [10,13,1],
                [13,29,2],
                [29,32,1],
                [32,40, 0]
            ]
        },
        "outliers": {
            "min_percentile": 0.05,
            "max_percentile": 0.95
        }
    },
    "ename:Ph":{
        "key": "gs1:Ph",
        "label": "pH",
        "order": 4,
        "udm": "pH",
        "min": 7.5,
        "max": 8.5,
        "deviceFile": "ph",
        "gauge": {
            "id": "ph",
            "arcs": [
                [0, 7, 0],
                [7,7.5,1],
                [7.5,8.5,2],
                [8.5,9,1],
                [9,10, 0]
            ]
        },
        "outliers": {
            "min_percentile": 0.05,
            "max_percentile": 0.95
        }
    },
   
    "ename:Torbidita":{
        "key": "gs1:Torbidity",
        "label": "Torbidità",
        "order": 3,
        "udm": "NTU",
        "min": 6,
        "max": 50,
        "deviceFile": "torbidita",
        "gauge": {
            "id": "torb",
            "nOfLevels": 5,
            "arcs": [
                [0, 10, 2],
                [10,100,1],
                [100,200,0],

            ]
        },
        "outliers": {
            "min_percentile": 0,
            "max_percentile": 0.95
        }
    },
    "ename:Conduttivita_elettrica":{
        "key": "gs1:Conductivity",
        "label": "Salinità",
        "order": 2,
        "udm": "g/l",
        "min": 0,
        "max": 50,
        "deviceFile": "condut_elettrica",
        "gauge": {
            "id": "c_elettr",
            "nOfLevels": 5,
            "arcs": [
                [0, 15, 0],
                [15,24,1],
                [24,35,2],
                [35,38,1],
                [38,50, 0]
            ]
        },
        "outliers": {
            "min_percentile": 0.05,
            "max_percentile": 0.95
        }
    }
}

const locationColor = {
    "http://main.climavibe.com.ichain.pro/codes/loc/1.0": "#ff0000ff",
    "http://main.climavibe.com.ichain.pro/codes/loc/2.0": "#0037ffff",
    "http://main.climavibe.com.ichain.pro/codes/loc/3.0": "#22c01aff"
}
const gaugeColors = ["#F28B82", "#FDD663", "#81C995"]

const LbiMeasureGauge = ({t, classes, device, sglns, totalTimerange, activeDomain, ignoreOutlier, updateKpiCallback}) => {
    const arcMin = devicesConf[device._id].gauge.arcs[0][0];
    const arcMax = devicesConf[device._id].gauge.arcs.slice(-1).pop()[1];

    const [{series, loading}, setSeries] = useState({series: new Map(), loading:true})
    const [grouped, setGrouped] = useState(true);
    const [valori, setValori] = useState(new Map());

    useEffect( () => {
        const fetchSensorData = async() => {
            try {
                const allRequests = []
                const locationRequest = sglns?.data?.map( (l) => 
                    axios.get(`/api/dataservices/sensor_data/`,{
                        params: {
                            where: l.sgln,
                            type_of_report: device._id,
                            start: Moment(totalTimerange.begin()).format('YYYY-MM-DD HH:mm:ss'),
                            end: Moment(totalTimerange.end()).format('YYYY-MM-DD HH:mm:ss'),
                            domain: activeDomain
                        }
                    }).then((response) => ({
                        device: device,
                        location: l,
                        data: response.data
                    }))
                )
                allRequests.push(...locationRequest)
                
                const results = await Promise.all(allRequests);
                const series = new Map();
                results?.map((r) => {
                    const column = devicesConf[r.device._id].key
                    
                    let points = r.data?.records?.map((row) => [new Date(row["timestamp"]).getTime(), parseFloat(row[column])])
                    if (points.length>0){
                        points.sort((a,b)=> a[1]-b[1])
                        const ts = {
                            name: devicesConf[r.device._id].label,
                            columns: ["time", "value"],
                            points: points
                        }
                        if (r.device._id === "ename:Conduttivita_elettrica"){
                            const coeff = 0.00064;
                            const eventi_salinita = ts.points.map( ([time,value]) => ([time, value * coeff]));
                            ts.points = eventi_salinita
                        }
                        if (ts.points.length>0)
                            series.set(r.location.sgln, ts)
                    }
                })
                
                setSeries({series: series, loading: false});//qua ci andrebbe la set
            }
            catch (err) {console.log(err)}
        }
        setSeries({series:new Map(), loading:true});
        fetchSensorData();
    },[device, sglns, totalTimerange, activeDomain]);
    
    const my_avg = useMemo(()=>{
        
        if (series.size>0){
            const valori= new Map();
            series.entries().forEach(([key, ts]) => {
                if (ignoreOutlier){
                    const max_p_index = Math.floor(devicesConf[device._id].outliers.max_percentile * (ts.points.length -1));
                    const min_p_index = Math.floor(devicesConf[device._id].outliers.min_percentile * (ts.points.length -1));
                    const max_p_value = ts.points[max_p_index][1];
                    const min_p_value = ts.points[min_p_index][1];
                    const real_points = ts.points.filter(v=> v[1]>=min_p_value && v[1]<= max_p_value);
                    valori.set(key, real_points.reduce((a,b)=>(a + b[1]),0) / real_points.length);
                }
                else{
                    valori.set(key, ts.points.reduce((a,b)=>(a + b[1]),0) / ts.points.length);
                }
            })
            setValori(valori);
            const c_avg = [...valori.entries()].reduce((a,b)=> (a+b[1]), 0) / valori.size;
            return c_avg;
        }
        else{
            return arcMin;
        }
    },[series,ignoreOutlier])

    useEffect(()=>{
        let v_kpi=0;
        for ( const arc of devicesConf[device._id].gauge.arcs){
            if (my_avg>arc[0] && my_avg<=arc[1]){
                v_kpi=arc[2]
                break;
            }
        }
        updateKpiCallback(device._id, v_kpi);
    }
    ,[my_avg])

    return  (<Paper className={classes.GaugeChart} style={{width:"100%"}} >
                <Box name={`title_${device._id}`} justifyContent={"center"}>
                    <Box justifyItems={"center"}>
                        <Typography variant={"h6"}>{t(`climavibeLbiChart.graph.titles.${devicesConf[device._id].gauge.id}`)}</Typography>
                    </Box>
                    <Box ml="1em">
                        <FormControlLabel name={`ck_grouped_${device._id}`} 
                            control={
                                <Checkbox size="small" color="primary" checked={grouped} onChange={()=>setGrouped((prev)=> (!prev))}/>
                            }
                            label={t('climavibeLbiChart.filterBy.showGrouped')}
                        />
                    </Box>
                </Box>
                {grouped?
                    <Box name={`single_gauge_${device._id}`}>
                        <GaugeErrorBoundary>
                            <GaugeComponent id={`g_chart_${devicesConf[device._id].gauge.id}`}
                                type="semicircle"
                                pointer={{
                                    color: '#345243',
                                    length: 0.80,
                                    width: 15,
                                }}
                                value={my_avg}
                                minValue={arcMin}
                                maxValue={arcMax}
                                arc={{
                                    padding: 0.005,
                                    cornerRadius: 1,
                                    subArcs: devicesConf[device._id].gauge.arcs.map(arc=>{ return {
                                        limit:arc[1],
                                        color: gaugeColors[arc[2]],
                                        showTick: true
                                    }})

                                }}
                                labels={{
                                    valueLabel:{
                                        hide: true
                                    },
                                    tickLabels:{
                                        defaultTickValueConfig:{
                                            style:{fontSize:"0.7rem"}
                                        }
                                    }                        
                                }}
                            />
                        </GaugeErrorBoundary>
                        <Box mt={0} justifyItems={"center"}>
                            <Typography
                                style={{fontSize: '0.9rem'}}>{loading?t('actions.loading'):`${Math.round(my_avg*100)/100} ${devicesConf[device._id].udm}`}</Typography>
                        </Box>
                    </Box>
                :
                    <Box>
                        <Grid container spacing={2}>
                        {[...valori.entries()].map(([sgln,avg])=>(
                            <Grid key={`geb_${device._id}_${sgln}`} item md={6}>
                                <Box>
                                    <Box justifyItems={"center"}>
                                        <Typography variant={"h6"} style={{fontSize:"0.8rem"}}>{sglns.data.find(s=>s.sgln===sgln).name}</Typography>
                                    </Box>
                                    <GaugeErrorBoundary >
                                        <GaugeComponent id={`g_chart_${devicesConf[device._id].gauge.id}_${sgln}`}
                                            type="semicircle"
                                            pointer={{
                                                color: '#345243',
                                                length: 0.80,
                                                width: 15,
                                            }}
                                            value={avg}
                                            minValue={arcMin}
                                            maxValue={arcMax}
                                            arc={{
                                                padding: 0.005,
                                                cornerRadius: 1,
                                                subArcs: devicesConf[device._id].gauge.arcs.map(arc=>{ return {
                                                    limit:arc[1],
                                                    color: gaugeColors[arc[2]],
                                                    showTick: true
                                                }})

                                            }}
                                            labels={{
                                                valueLabel:{
                                                    hide: true
                                                },
                                                tickLabels:{
                                                    defaultTickValueConfig:{
                                                        style:{fontSize:"0.7rem"}
                                                    }
                                                }
                                            }}
                                        />
                                    </GaugeErrorBoundary>
                                    <Box mt={0} justifyItems={"center"}>
                                        <Typography
                                            style={{fontSize: '0.9rem'}}>{loading?t('actions.loading'):`${Math.round(avg*100)/100} ${devicesConf[device._id].udm}`}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                        </Grid>
                    </Box>
                }
                
                
            </Paper>)
}

const LbiGlobalGauge = forwardRef(({t, classes, kpiMap, ...props},ref) => {
    const internalRef = useRef(null);
    const [kpi_value, setKpiValue] = useState(0)

    useEffect(()=>{
        if (ref){
            if (typeof ref =="function"){
                ref(internalRef.current);
            }
            else {
                ref.current=internalRef.current
            }
        }
    }, [ref]);

    // Cleanup sicuro: azzeriamo il ref invece di cancellarlo
    useEffect(() => {
        return () => {
        if (internalRef.current) {
            internalRef.current = null;
        }
        };
    }, []);

    useEffect(()=>{
        if (kpiMap.size){
            setKpiValue(kpiMap.entries().reduce((a,b)=>(a+ b[1]),0)/(kpiMap.size*2));
        }
        else{
            setKpiValue(0);
        }
        
    },[kpiMap])

    return (<Paper className={classes.GaugeChart} >
        <Box justifyItems={"center"}>
            <Typography variant={"h6"}>{t("climavibeLbiChart.graph.titles.global")}</Typography>
        </Box>
        <GaugeErrorBoundary><GaugeComponent ref={internalRef} id="gauge_chart_global_lagoon_index"
            type="semicircle"
            value={Math.round(kpi_value * 100) / 100}
            minValue={0}
            maxValue={1}
            marginInPercent={{ top: 0.08, bottom: 0.07, left: 0.07, right: 0.07 }}
            arc={{
                padding: 0.05,
                cornerRadius: 5,
                subArcs: [
                    {
                        limit: 0.2,
                        color: "#000000",
                        showTick: true,
                        tooltip: {
                            text:t('climavibeLbiChart.messages.tooltip.black'),
                            style: {whiteSpace:"pre-wrap"}
                        }
                    },
                    {
                        limit: 0.5,
                        color: gaugeColors[0],
                        showTick: true,
                        tooltip: {
                            text:t('climavibeLbiChart.messages.tooltip.red'),
                            style: {whiteSpace:"pre-wrap"}
                        }
                    },
                    {
                        limit: 0.8,
                        color: gaugeColors[1],
                        showTick: true,
                        tooltip: {
                            text:t('climavibeLbiChart.messages.tooltip.yellow'),
                            style: {whiteSpace:"pre-wrap"}
                        }
                    },
                    {
                        limit: 1,
                        color: gaugeColors[2],
                        showTick: true,
                        tooltip: {
                            text:t('climavibeLbiChart.messages.tooltip.green'),
                            style: {whiteSpace:"pre-wrap"}
                        }
                    },
            ]
            }}
            labels={{
                valueLabel:{
                    hide: false
                },
                tickLabels:{
                    defaultTickValueConfig:{
                        style:{fontSize:"0.8rem"}
                    }
                }
            }}
            pointer={{type: "blob", elastic: true}}
        /></GaugeErrorBoundary>
        {/*<Box mt={0} justifyItems={"center"}>
            <Typography
                style={{fontSize: '1.1rem'}}>{Math.round(kpi_value*100)/100}</Typography>
        </Box>*/}
    </Paper>)
});

const ClimavibeLbiChart =  () => {
    const ReactGridLayout = WidthProvider(RGL);
    const authContext = useContext(AuthContext);
    const {primaryColor, secondaryColor, backgroundColor, accentColorAlpha, accentColor } = useContext(ThemeContext)
    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
            '& label.Mui-focused': {
                color: 'black',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: accentColor,
            },
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderColor: accentColor,
                },
            },
            '& .MuiIconButton-colorInherit': {
                color: accentColor
            },
            '& ..MuiAutocomplete-inputRoot': {
                maxHeigth: '30px'
            }
        },
        chip: {
            marginRight: '1%',
            color: accentColor,
            border: '1px solid ' + accentColor,
            fontWeight: 'bold',
            backgroundColor: 'transparent'
        },
        button: {
            backgroundColor: accentColor,
            color: "white",
            fontWeight: 'bold',
            marginLeft: '2%',
            borderRadius: '20px',
        },
        paper: {
            paddingTop: '1%',
            paddingLeft:'2%',
            paddingBottom: '5%',
            paddingRight: '2%',
            fontSize: 'small'
        },
        graph_tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            fontWeight: 'thin',
            borderRadius: '5px',
            border: '1px solid ',
            padding: '0.25em',
            //minWidth: '310px'            
        },
        graph_tooltip_inner: {
            marginLeft: '1em',
            marginRight: '1em',
            whiteSpace: 'nowrap'
        },
        dot: {
            height: '20px',
            width: '20px',
            borderRadius: '50%',
            display: 'inline-block',
        },
        box: {
            width: '100%',
            //height: '100%',
            padding: '8px',
        },
        box2: {
            width: '100%',
            height: '100%',
            padding: '8px',
            overflow: 'hidden'
        },
        boxBar: {
            width: '100%',
            height: '100%',
            padding: '8px',
        },
        boxLeft: {
            height: '100%',
            width: '18%',
            margin: '0px',
            float: 'left',
        },
        boxInsideLeft: {
            height: '100%',
            position: 'relative',
        },
        gridLayoutLeft: {
            backgroundColor: backgroundColor,
            top: 0, left: 0, right: 0,
            margin: 'auto',
            borderRadius: '8px',
            height: '100%'
        },
        boxRight: {
            height: '100%',
            width: '80%',
            margin: '0px',
            float: 'right',
        },
        editBox: {
            position: 'absolute',
            top: '0',
            right: '0',
        },
        titleBox: {
            position: 'absolute',
            top: '0',
            left: '0',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        titleBar: {
            fontWeight: "bolder",
            fontSize: '0.85rem'
        },
        iconEdit: {
            width: '0.75em',
            height: '0.75em',
        }
    }));
    const classes = useStyles()

    const { t } = useTranslation();
    
    const defaultProps = {
        className: "env_analysis_layout",
        cols: 12,
        rowHeight: 100,
        onLayoutChange: ()=>{}
    };

    function onLayoutChange(layout, name) {
        saveToLS(name, layout);
    }

    function getFromLS(key) {
        if (localStorage) {
            return JSON.parse(localStorage.getItem(`${authContext.userName}_${authContext.companyPrefix}_${key}`)) || []
        }
    }

    function saveToLS(key, value) {
        if (localStorage) {
            localStorage.setItem(`${authContext.userName}_${authContext.companyPrefix}_${key}`, JSON.stringify(value));
        }
    }

    

    const originalLayout = getFromLS("env_analysis_layout");
    const [state,] = useState(originalLayout)

    const minDate = Moment("2025-07-01 00:00");

    const [filter, setFilter] = useState({
        where: [],
        selectedDevices: {},
        nOfSelectedDevices: 0,
        currentMonthDate: Moment().toDate(),
        ignoreOutlier: true
    })
    
    const [totalTimerange, setTotalTimerange]= useState(new TimeRange(new Date(filter.currentMonthDate.getFullYear(), filter.currentMonthDate.getMonth(), 1), 
            new Date(filter.currentMonthDate.getFullYear(), filter.currentMonthDate.getMonth()+1,0)));
    
    const [kpi, updateKpi] = useState(new Map());

    const [{ data: sglns, loading:loadingSglns, error: errorSglns },] = useAxios({
        url: `/api/subplaces/?mine=true&not_mine=false&skip=0&limit=100&direction=1&domain=${authContext.activeMainDomain}`,
        useCache: false
    },
    )

    const [{ data: devices, loading:loadingDevices, error:errorDevices },] = useAxios({
        url: `/api/dataservices/records/_keys/?key_type=ename&domain=${authContext.activeMainDomain}`,
        useCache: false
    },
    )

    useEffect(()=>{
        const newFilter = {...filter, where: sglns?.data.map(s=>({ key: s.sgln, active: true}))}
        setFilter(newFilter); 
        },
        [sglns]
    )

    useEffect(()=>{
        const newSelectedDevices = {}
        devices?.forEach(v=> newSelectedDevices[v._id]=true)
        const nOfSelectedDevices= Object.values(newSelectedDevices).filter(value => value===true).length
        setFilter((prev)=>( {...prev, selectedDevices:newSelectedDevices, nOfSelectedDevices: nOfSelectedDevices}))
    }, [devices])

    useEffect(()=>{
            const startDate = new Date(filter.currentMonthDate.getFullYear(), filter.currentMonthDate.getMonth(), 1)
            const endDate = new Date(filter.currentMonthDate.getFullYear(), filter.currentMonthDate.getMonth()+1,0)
            setTotalTimerange(new TimeRange(startDate,endDate));
            setTracker((prev)=>({...prev, timerange: new TimeRange(startDate, endDate)}))
        },[filter.currentMonthDate])
    
    const updateKpiCallback = (key, v_kpi)=>{
        updateKpi((prev)=> new Map(prev).set(key,v_kpi));
    }

    const [{tracker, timerange, x, y}, setTracker] = useState({
        tracker: null,
        timerange: new TimeRange(totalTimerange),
        x: null,
        y: null
    })

    return (
        <div className={classes.root} id="climavibe_lbi_charts_page" style={{ height: "100%" }}>
            <ContainerDimensions>
                {({ width, height }) =>
                    <div style={{ height: height * 0.9, width: width}}>
                        <Box m={1} display={'flex'} alignItems={'end'}>
                            <FilterListIcon style={{ color: accentColor, marginRight: 16 }} />
                            <MonthPicker 
                                name={"choose_month"} 
                                minDate={minDate} 
                                state={filter.currentMonthDate} 
                                setState={(newMonthDate)=> setFilter((prev)=>({...prev, currentMonthDate: newMonthDate}))}
                                label={t('actions.filterBy', {by: t('climavibeLbiChart.filterBy.month')})}/>
                            <FormControlLabel 
                                control={
                                    <Checkbox color="primary" checked={filter.ignoreOutlier} onChange={()=>setFilter((prev)=> ({...prev, ignoreOutlier: !prev.ignoreOutlier}))}/>
                                }
                                label={t('climavibeLbiChart.filterBy.ignore_outlier')}
                            />

                        </Box>
                        { (loadingSglns || loadingDevices) ?
                            <Backdrop style={{ zIndex: 1000 }} open={loadingSglns || loadingDevices}><CustomLoader size={80} /></Backdrop>
                            :
                            <Grid container spacing={2}>
                                <Grid item md={3}></Grid>
                                <Grid item md={6}>
                                    <LbiGlobalGauge t={t}
                                        classes={classes}
                                        kpiMap={kpi}/>
                                </Grid>
                                <Grid item md={3}></Grid>
                                <Grid item md={12}>
                                    <Box display={"flex"} m={1}>
                                    {
                                        devices.filter(d=> devicesConf[d._id]).sort((a,b)=>devicesConf[a._id].order-devicesConf[b._id].order).map((device)=>(
                                            <Box key={`${device._id}_grid`} display={"flex"} m={1} width={"100%"} justifyContent={"center"} alignItems={"stretch"}>
                                                <LbiMeasureGauge  t={t} 
                                                    classes={classes} 
                                                    device={device} 
                                                    sglns={sglns} 
                                                    totalTimerange={timerange} 
                                                    ignoreOutlier={filter.ignoreOutlier}
                                                    activeDomain={authContext.activeMainDomain}
                                                    loadingColor={accentColor}
                                                    updateKpiCallback={updateKpiCallback}/>
                                            </Box>
                                        ))
                                    }
                                    </Box>
                                </Grid>
                                
                            </Grid>
                        }
                    </div>
                }
            </ContainerDimensions>
        </div>
    )
}

export default ClimavibeLbiChart